import type { ICSPRClickSDK } from '@make-software/csprclick-core-types';
import { createContext } from 'react';

import type { ActiveAccountType } from 'types';

interface WalletContextType {
  activeAccount: ActiveAccountType | null;
  isInitialized: boolean;
  signIn: () => void;
  buyCSPR: () => void;
  clickRef: ICSPRClickSDK;
  isClickLoaded: boolean;
}

export const WalletContext = createContext<WalletContextType | null>(null);
